import type { Category } from "@CommonApi/categories";
import { useSetAtom } from "jotai";
import { useModals } from "src/components/Modals";
import { importPdfSummaryExclusionsModalDataAtom } from "./atoms";

export const useImportPdfSummaryExclusionsModal = () => {
  const { openModal } = useModals();
  const setModalData = useSetAtom(importPdfSummaryExclusionsModalDataAtom);

  const openImportPdfSummaryExclusionsModal = (category: Category) => {
    setModalData(category);
    openModal("ModalImportPdfSummaryExclusions");
  };

  return { openImportPdfSummaryExclusionsModal };
};
